export default __webpack_public_path__ + "images/ef82397db6385ab1b980cbd3c91d83fd-petsandanimals_small.webp";